module.exports = __webpack_public_path__ + "static/freeapp-letters-of-admin-4b2e7517f941695f07fc5857d7fc7ae9.png";